<div class="form-group">
  <span class="icon id-number"></span>
  <div class="inputs">
    <label for="cpf-clientef">Renavam</label>
    <input
      #renavanInput
      name="renavam"
      type="text"
      [justNumber]="true"
      class="form-control"
      [(ngModel)]="fichaCadastro.codRenavam"
      placeholder="Digite o Renavam (opcional)"
      uppercase
      maxlength="11"
      (blur)="validaRenavam()"
    />
  </div>
</div>
<h2>Observações</h2>
<div class="row">
  <div class="col-xs-12">
    <div class="form-group text-box column-custom">
      <textarea
        name="observacao"
        [(ngModel)]="observacao"
        (ngModelChange)="onChangeObs(observacao)"
        id="user-observations"
        class="form-control"
        cols="30"
        rows="10"
        maxlength="2000"
      ></textarea>
      <h5 class="caracteres">{{ countCaracteres }} / 2000</h5>
    </div>
  </div>
</div>
<div>
  <div
    class="avalista-card"
    [ngClass]="{ 'avalista-card_last': i === avalistasIncluidos.length - 1 }"
    *ngFor="let avalista of avalistasIncluidos; let i = index"
  >
    <app-avalista-card
      *ngIf="avalista.nome"
      [index]="i"
      [avalistas]="avalistasIncluidos"
      (remover)="removerAvalista(i)"
      (editar)="editarAvalista(i)"
      [avalista]="avalista"
    >
    </app-avalista-card>
  </div>
</div>
<div *ngIf="canAddAvalista" class="row">
  <div class="marginT30 form-group tab-buttons">
    <a
      (click)="abrirInclusaoAvalista()"
      class="bt-back btn btn-border-orange pull-left"
    >
      <i class="fa fa-user mrBt"></i> Incluir Avalista</a
    >
  </div>
</div>
<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a
      (click)="onClickPrevious()"
      class="bt-back btn btn-border-orange pull-left"
    >
      <i class="fa fa-arrow-left mrBt"></i> Voltar</a
    >
    <a (click)="onClickNext()" class="bt-go btn btn-full-orange pull-right"
      >Continuar
      <i class="fa fa-arrow-right mlBt"></i>
    </a>
  </div>
</div>

<!-- MODAL -->
<app-modal-message #modalMessage [hideClose]="hideClose" title="Atenção!">
</app-modal-message>

<app-modal-pesados-brasil
  #modalPesadosBrasil
  (confirmarEventEmitter)="confirmarPropostaPesadosBrasil()"
></app-modal-pesados-brasil>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
